import React, { useState, useEffect } from "react";
import axios from 'axios';
import './DiscrepancySubDivisionWise.css';
import { format, set } from 'date-fns';
import jsPDF from "jspdf";
import "jspdf-autotable";
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
import { useLocation } from "react-router-dom";
const DiscrepancySubDivisionWise = () => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [showTable, setShowTable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    //const sortedStockData = sortData(stockData);
    const location = useLocation();
    const fpsIdFromQuery = new URLSearchParams(location.search).get('fpsId'); // Get fpsId from query params

    const getRowClass = (fpsId) => {
        return fpsId === fpsIdFromQuery ? 'highlight-row' : '';
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const [sortedStockData, setSortedStockData] = useState([]);


    // 🔹 Fetch data automatically when component loads
    useEffect(() => {
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getFullYear())}-${String(
            currentDate.getMonth() + 1
        ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;

        const payload = { startDate: formattedDate };
        setFromDate("29-08-2025");  // You can make this dynamic if needed
        setToDate(
            `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`
        );
        console.log("Sending payload on page load:", payload);

        setIsLoading(true); // 🔹 Start loading before API call

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/reports/discrepancy2-response-status`, payload)
            .then((res) => {
                console.log("API Response:", res.data);
                setSortedStockData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                setSortedStockData([]); // reset data on error
            })
            .finally(() => {
                setIsLoading(false); // 🔹 Stop loading after API finishes
            });
    }, []);


    const generateXl = () => {
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Discrepancy Report - (ZOD)');
        worksheet.mergeCells('A1:K1'); // Merge cells for the title
        // Set the cell value with both the date and time
        /// Set the title in the merged cells
        worksheet.getCell('A1').value = `Discrepancy Report - (ZOD)`;

        // Center-align the text in the merged cell
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { bold: true, size: 12 };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { size: 16, bold: true, color: { argb: 'F7912B' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };

        // worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.mergeCells('A2:K2'); // Merge cells for the title
        // Set the cell value with both the date and time
        /// Set the title in the merged cells
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`;

        // Center-align the text in the merged cell
        worksheet.getCell('A2').alignment = { horizontal: 'center' };


        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

        worksheet.getRow(2).font = { bold: true, size: 12 };
        worksheet.getRow(2).alignment = { horizontal: 'right' };
        worksheet.getRow(2).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: '000000' }  // Background color: Whitesmoke (ARGB format)
        };
        // ✅ From - To Date Row
        worksheet.mergeCells('A3:K3');
        worksheet.getCell('A3').value = `From Date : ${fromDate}    To Date : ${toDate}`;
        worksheet.getRow(3).alignment = { horizontal: 'left' };
        worksheet.getRow(3).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(3).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: '000000' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.addRow(
            ['S.No',
                'District',
                'Sub Division',
                'Total No.of FPS Shops',
                'No.of FPS Shops Inspected',
                '% of FPS Shops Inspected',
                'Less Quantity',
                'Bad Quality',
                'Stock deviation',
                'No Distribution',
                'Miscellaneous Complaints']);
        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 11; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }
        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 20 },  // Column C width
            { key: 'D', width: 30 },  // Column D width
            { key: 'E', width: 30 },  // Column E width
            { key: 'F', width: 30 },  // Column F width
            { key: 'G', width: 20 },  // Column D width
            { key: 'H', width: 20 },  // Column D width
            { key: 'I', width: 20 },  // Column D width
            { key: 'J', width: 20 },  // Column D width
            { key: 'K', width: 20 },  // Column D width

            // { key: 'I', width: 25 },
        ];

        // Add data rows from sortedStockData (not setSortedStockData)
        sortedStockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1, // S.No
                capitalizeFirstLetter(data.districtName || 'N/A'),
                capitalizeFirstLetter(data.subDivisionName || 'N/A'),
                data.totalFpsShops || 0,
                data.fpsShopsInspected || 0,
                data.percentageInspected || 0,
                data.complaints || 0,
                data.qualityComplaints || 0,
                data.stockDeviation || 0,
                data.noDistribution || 0,
                data.miscellaneous || 0,

            ]);
            // Adjust alignment for 'fpsId' (column 6) and 'startTime' (column 7) and center 'S.No' (column 0)
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // Column 0 (S.No)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 2 || colNumber === 3) {  // Columns 6 (fpsId) and 7 (startTime)
                    cell.alignment = { horizontal: 'left' };  // Right align for fpsId and startTime
                } else {
                    cell.alignment = { horizontal: 'right' };  // Left align for all other columns
                }
            });
        });
        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Discrepancy_Report_(ZOD).xlsx';
            link.click();
        });
    }

    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [233, 290] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9.5, 1, 215, 40);  // Image format: 'PNG'
        const pageWidth = doc.internal.pageSize.width;
        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position
        // Set the report title with a styled color
        const title = 'Discrepancy Report - (ZOD)';  // Title for the report
        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title
        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);
        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background
        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position
        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black
        let currentYPosition = 55.21;
        currentYPosition += 5;  // Adjust space for next content if needed
        // Get the current date and time
        const currentDate = new Date();
        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);
        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title
        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition, { align: 'right' });
        currentYPosition += 5;
        // ✅ Add From - To date (left side)
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);

        // Align left by setting x = 10 (left margin)
        doc.text(`From Date : ${fromDate}   To Date : ${toDate}`, 10, currentYPosition, { align: 'left' });
        currentYPosition += 5;


        // Generate the rest of the table (data rows, etc.) if required
        const headers = [
            'S.No',
            'District',
            'Sub Division',
            'Total No.of FPS Shops',
            'No.of FPS Shops Inspected',
            '% of FPS Shops Inspected',
            'Less Quantity',
            'Bad Quality',
            'Stock deviation',
            'No Distribution',
            'Miscellaneous Complaints'

        ];
        const rows = sortedStockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.districtName || 'N/A'),
            capitalizeFirstLetter(data.subDivisionName || 'N/A'),
            data.totalFpsShops || 0,
            data.fpsShopsInspected || 0,
            data.percentageInspected || 0,
            data.complaints || 0,
            data.qualityComplaints || 0,
            data.stockDeviation || 0,
            data.noDistribution || 0,
            data.miscellaneous || 0,
        ]);
        doc.autoTable({
            head: [headers],
            body: rows,
            startY: currentYPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No - Center alignment
                1: { cellWidth: 25, halign: 'left' },    // District - Left alignment
                2: { cellWidth: 25, halign: 'left' },    // Subdivision - Left alignment
                3: { cellWidth: 20, halign: 'right' },    // Block Name - Left alignment
                4: { cellWidth: 20, halign: 'right' },    // Panchayat Name - Left alignment
                5: { cellWidth: 20, halign: 'right' },   // FPS ID - Right alignment
                6: { cellWidth: 16, halign: 'right' },   // Start Time - Right alignment
                7: { cellWidth: 20, halign: 'right' },   // FPS ID - Right alignment
                8: { cellWidth: 17, halign: 'right' },   // Start Time - Right alignment
                9: { cellWidth: 20, halign: 'right' },
                10: { cellWidth: 20, halign: 'right' },

            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 8,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });

        // Save the generated PDF
        doc.save('Discrepancy_Report_(ZOD).pdf');
    };


    return (
        <div className="discrepancy-wise-repo">
            <div className="discrepancy-wise-group">
                <div className="discrepancy-wise-group-1">
                    <button onClick={generatePDF} className="discrepancy-wise-button">
                        DOWNLOAD PDF
                    </button>
                    <button onClick={generateXl} className="discrepancy-wise-button">
                        DOWNLOAD XLSX
                    </button>
                </div>
            </div>

            <div className="discrepancy-wise-card-head">
                Discrepancy Report - (ZOD)
                <div className="discrepancy-wise-date-range">
                    <span style={{ color: "#2a6d86", fontWeight: "Normal" }}>From Date : </span> {fromDate} &nbsp;&nbsp;
                    <span style={{ color: "#2a6d86", fontWeight: "Normal" }}>To Date : </span> {toDate}
                </div>
            </div>
            <table className="discrepancy-wise-table">

                <thead>
                    <tr>
                        <th>S.No.</th>
                        {/* <th>Division</th> */}
                        <th>District</th>
                        <th>Sub Division</th>
                        <th>Total No.of FPS Shops</th>
                        <th>No.of FPS Shops Inspected</th>
                        <th>% of FPS Shops Inspected</th>
                        <th>Less Quantity</th>
                        <th>Bad Quality</th>
                        <th>Stock deviation</th>
                        <th>No Distribution</th>
                        <th>Miscellaneous Complaints</th>
                    </tr>
                </thead>
                {showTable && (
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="12" style={{ textAlign: "center" }}>Loading...</td>
                            </tr>
                        ) : sortedStockData.length > 0 ? (
                            sortedStockData.map((data, index) => (
                                <tr key={`${data.username}-${index}`} className={getRowClass(data.username)}>
                                    <td>{index + 1}</td>
                                    <td>{capitalizeFirstLetter(data.districtName || "N/A")}</td>
                                    <td>{capitalizeFirstLetter(data.subDivisionName || "N/A")}</td>
                                    <td>{data.totalFpsShops || 0}</td>
                                    <td>{data.fpsShopsInspected || 0}</td>
                                    <td>{data.percentageInspected || 0}</td>
                                    <td>{data.complaints || 0}</td>
                                    <td>{data.qualityComplaints || 0}</td>
                                    <td>{data.stockDeviation || 0}</td>
                                    <td>{data.noDistribution || 0}</td>
                                    {/* <td>{data.stockDeviationCount || 0}</td> */}
                                    <td>{data.miscellaneous || 0}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" style={{ textAlign: "center", color: "red" }}>
                                    No Data Available
                                </td>
                            </tr>
                        )}
                    </tbody>

                )}
            </table>

        </div>
    );
};
export default DiscrepancySubDivisionWise;